<template>
  <b-row>
    <b-col sm="10" class="imp">{{ text }}</b-col>
  </b-row>
</template>
<script>
export default {
  name: "Important",
  props: {
    text: String
  }
};
</script>
<style lang="scss">
.imp {
  border-left: 5px solid #fff3c3;
  
  margin-bottom: 2.5%;
  margin-top: 2.5%;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  padding-left: 2%;
  padding-top: 1%;
  padding-bottom: 1%;
  z-index: 1;

  color: #4f4f4f;
}
</style>
